import { z } from "zod";
import { ENDING_RARITY_VALUES } from "../../constants/ending-rarity.js";
import { ENDING_NAME_MAX_LENGTH } from "../../constants/limits.js";
import { FlagConditionSchema } from "./flags.js";
export const EndingDefinitionSchema = z.object({
    id: z.uuid(),
    name: z.string().min(1).max(ENDING_NAME_MAX_LENGTH),
    endingNumber: z.number().int().positive(),
    rarity: z.enum(ENDING_RARITY_VALUES),
});
export const EndingRuleSchema = z.object({
    id: z.uuid(),
    endingId: z.uuid(),
    priority: z.number().int().nonnegative(),
    conditions: z.array(FlagConditionSchema),
});
